<div class="videos" *ngIf="videoList.length > 0">
    <div class="videos-margin" fxLayout="column" fxLayoutGap="48px">

        <div fxLayout="row" fxLayoutAlign="center center">
            <span class="title">Vídeos</span>
        </div>

        <swiper class="swiper-container video-swiper" [config]="config" style="width: 100%;">

            <div class="swiper-slide" *ngFor="let vid of videoList">
                <div fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <iframe class="video-height" style="border-radius: unset !important;"
                            allowfullscreen="allowfullscreen" [src]="vid.video | safe: 'resourceUrl'">
                        </iframe>
                    </div>

                    <div class="video-title-margin">
                        <span>{{vid.textoVideo}}</span>
                    </div>
                </div>
            </div>
        </swiper>

    </div>
</div>